import { Tag } from "antd";
import { chartColors } from "components/charts/constants";
import { UserType as UserTypeEnum } from "components/CurrentUser/constants";
import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "themes/useTheme";

interface Props {
  type?: UserTypeEnum;
}

const UserType: React.FC<Props> = (props) => {
  const { type } = props;
  const { t } = useTranslation();
  const { themeVariables } = useTheme();
  switch (type) {
    case UserTypeEnum.SELLER: {
      return (
        <Tag color={themeVariables.statusColors["PENDING"]}>
          {t("account.user_management.user.user_type.seller")}
        </Tag>
      );
    }
    case UserTypeEnum.KOL: {
      return (
        <Tag color={themeVariables.statusColors["READY"]}>
          {t("account.user_management.user.user_type.kol")}
        </Tag>
      );
    }
    case UserTypeEnum.AFFILIATOR: {
      return (
        <Tag color={themeVariables.statusColors["COMPLETE"]}>
          {t("account.user_management.user.user_type.affiliator")}
        </Tag>
      );
    }
    case UserTypeEnum.PARTNER: {
      return (
        <Tag color={themeVariables.statusColors["DESTROY"]}>
          {t("account.user_management.user.user_type.partner")}
        </Tag>
      );
    }
    case UserTypeEnum.OPERATOR: {
      return (
        <Tag color={themeVariables.statusColors["UNDERREVIEW"]}>
          {t("account.user_management.user.user_type.operator")}
        </Tag>
      );
    }
    case UserTypeEnum.ALL: {
      return (
        <Tag color={chartColors[9]}>
          {t("account.user_management.user.user_type.all")}
        </Tag>
      );
    }
    case null:
    case undefined: {
      return null;
    }
    default: {
      return <Tag>{type}</Tag>;
    }
  }
};

export default UserType;
